import { useEffect, useState } from 'react';
import { collection, query, where, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/config';
import { useAuth } from '../contexts/AuthContext';

const STATUS_PRIORITY = { in_progress: 0, delivered_pending: 1, matched: 2 };

function sortActiveOrders(orders) {
  return [...orders].sort((a, b) => {
    const pDiff = (STATUS_PRIORITY[a.status] ?? 3) - (STATUS_PRIORITY[b.status] ?? 3);
    if (pDiff !== 0) return pDiff;
    const tA = a.scheduledAt?.toDate?.()?.getTime() ?? Infinity;
    const tB = b.scheduledAt?.toDate?.()?.getTime() ?? Infinity;
    return tA - tB;
  });
}

// Returnerer sjåførens aktive oppdrag (matched, in_progress, delivered_pending), sortert etter hastegrad
export function useDriverActiveOrder() {
  const { currentUser } = useAuth();
  const [activeOrders, setActiveOrders] = useState([]);
  const [loading, setLoading]           = useState(true);

  useEffect(() => {
    if (!currentUser) return;

    const q = query(
      collection(db, 'orders'),
      where('driverUid', '==', currentUser.uid),
      where('status', 'in', ['matched', 'in_progress', 'delivered_pending'])
    );

    const unsubscribe = onSnapshot(q, (snap) => {
      const orders = snap.docs.map(d => ({ id: d.id, ...d.data() }));
      setActiveOrders(sortActiveOrders(orders));
      setLoading(false);
    });

    return unsubscribe;
  }, [currentUser]);

  return { activeOrders, activeOrder: activeOrders[0] ?? null, loading };
}
